"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const IconButton_1 = require("../IconButton");
const Input_1 = require("../Input");
const SearchBar = (props) => {
    const { variant = "default", onClickSearch, disabled } = props;
    const iconVariant = variant === "default" ? "fill" : "transparent";
    const searchIcon = react_1.default.useMemo(() => (react_1.default.createElement(IconButton_1.IconButton, { shape: "square", variant: iconVariant, icon: "magnifying-glass", size: "sm", "aria-label": "Search", disabled: disabled, sx: { marginInlineEnd: -2 }, onClick: onClickSearch })), [disabled, iconVariant, onClickSearch]);
    return (react_1.default.createElement(foundations_1.Box, { sx: { position: "relative" } },
        react_1.default.createElement(Input_1.Input, Object.assign({ searchIcon: searchIcon }, props, { onEnter: onClickSearch }))));
};
exports.SearchBar = SearchBar;
//# sourceMappingURL=SearchBar.js.map